module.exports = __webpack_public_path__ + "static/media/vibino-feature-blur photo-PIC6.acfe0427.jpg";